import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { SendTicketResponse } from '../api/hub-responses/send-ticket-response';
import { SupportTicketRequestData } from './support-ticket-request-data';
import { container } from '../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../utils/container/service-ids';
import { FlagNames } from '../utils/feature-flags/flag-names';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export function sendSupportTicket(data: SupportTicketRequestData): Promise<boolean|string> {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();
    const hubApi = getHubApi();

    return (isHubApiEnabled
        ? hubApi.sendSupportMessage(window.app.deviceIdentifier, data)
        : HubJsonRpcRequest.makeRequest<SendTicketResponse, SupportTicketRequestData>(
            HubApiMethods.SEND_SUPPORT_MESSAGE,
            data,
            window.app.deviceIdentifier
        ))
        .then((response) => {
            if (response !== 1) {
                return 'Bad response';
            }

            return true;
        })
        .catch((error) => error.message);
}
